<!------------------------------------------------------------------------------
  Copyright (c) 2018. keni

  This file SeasonTicketList.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  SeasonTicketList.vue can not be copied and/or distributed
  without the express permission of keni
  ----------------------------------------------------------------------------->

<!------------------------------------------------------------------------------
 File: SeasonTicketList 
 Created by keni.
 with: IntelliJ IDEA
 Date: 11/09/2018
 Time: 14:35
------------------------------------------------------------------------------->
<template>
    <buy-button
            @buttonClick="addToBasket()"
            :ticket="null"
            :can_buy_now="false"
            :event_expired="event_expired"
            :limited="limited"
            :sold_out="sold_out"
            :ticket_price="ticket_price"
            :ticket_id="ticket_id"
    >
    </buy-button>
</template>

<script>
	import {format as formatMoney} from '../../../../../app/Shared/Resources/Assets/js/helpers/money';

	Vue.component('vue-btn', require('../../../../../app/Shared/Resources/Assets/js/components/buttons/Buttons.vue'));
	Vue.component('buy-button', require('../../../../../app/Shared/Resources/Assets/js/components/buttons/BuyButton.vue'));

	export default {
		name: "season-ticket-list-item",
		components: {},
		props: {
			event_expired: String,
			target_id: String,
			limited: String,
			sold_out: String,
			ticket_price: String,
			ticket_events: Array,
			add_ticket_url: String,
			ticket_id: String
		},
		created() {
		},
		destroyed() {
		},
		mounted() {

		},
		data() {
			return {
				toastr_options: {
					newestOnTop: true,
					progressBar: true,
					timeOut: 6000,
					positionClass: "toast-top-right",
					showMethod: 'slideDown',
					hideMethod: 'slideUp',
					showDuration: "200",
				},
				toastr_last: {},
				tickets_clicked: []
			}
		},
		methods: {
			formatMoney(price) {
				return formatMoney(price, {
					code: $('body').data('currency')
				});
			},
			addToBasket() {
				let self = this;
// console.log('addToBasket');
				this.showToastr('info', {message: 'checking for available tickets'});

				self.addTicketToBasket(function (response) {

					// console.log('toastr', 'toastr',toastr);
					console.log('self.addTicketToBasket', 'response.data',response.data);
					// console.log('test', 'response.data ', toastr.options);

					if (response.data.sold_out === true) {
						toastr.clear(self.toastr_last);
						self.tickets_clicked = self.removeTicketFromWaitingList();
						self.showToastr('warning', {message: 'this ticket is sold out'});
						// console.log('test', 'response.data ', response.data);

					}
                    else if(response.data.exceeded === true){
                        let maxNumberOfTickets = response.data.limit;

                        toastr.clear(self.toastr_last);
                        self.tickets_clicked = self.removeTicketFromWaitingList();
                        self.showToastr('warning', {message: 'Only '+maxNumberOfTickets+' per purchase'});
                    }
					else {
						// console.log('test', 'test');
						setTimeout(function () {
							toastr.clear();
							setTimeout(function () {
								// remove reserve from ticket adding process
								self.tickets_clicked = self.removeTicketFromWaitingList();
								// window.modalBasketVue.$children[0].readBasket();
								self.$basketController.$emit('read_basket', self.ticket_id);

							}, 600);
						}, 600);

					}
				});
			},
			removeTicketFromWaitingList() {
				let self = this,
					index = _.indexOf(self.tickets_clicked, self.ticket_id);

				if (index > -1) {
					self.$delete(self.tickets_clicked, index);
				}

				return self.tickets_clicked;
			},
			showToastr(type, params) {
				let self = this,
					title = ('title' in params) ? `<div>${params.title}</div>` : '',
					message = `<div class="p-3">${params.message}</div>`
				;
				toastr.options = self.toastr_options;

				self.toastr_last = toastr[type](
					`${title}
		            ${message}`
				);
			},
			addTicketToBasket(callback) {
				// console.log('this.add_ticket_url', this.add_ticket_url, `${this.add_ticket_url.data}/${ticket.id}`);
				let data = {};
				this.tickets_clicked.push(self.ticket_id);

				axios.post(this.add_ticket_url, data)
					.then(function (response) {
						// console.log('response.data',response.data);
						callback(response);
					})
					.catch(function (e) {
					});
			},
		},
		watch: {
			ticket_events: function (newItem, old) {
				console.log('q', 'new', newItem, old);
			}
		},
		computed: {}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/tickets/SeasonTicketListItem.vue